// Браузерный клей Метрики (T9): вставка штатного тега счётчика и отправка целей.
// window.ym — контракт самой Метрики; единственное глобальное имя, которое мы трогаем
// на чужой странице (осознанное исключение из правила «scope не загрязнять»).
// Чистая логика (карта целей, буфер, дедуп) — в lib/metrika.js.

const TAG_SRC = "https://mc.yandex.ru/metrika/tag.js";

// Подключить счётчик id, если его ещё нет на странице (на Тильде обычно уже стоит свой;
// на /demo и /status — нет). Повторный init того же id (гонка с тегом Тильды) даёт
// предупреждение в консоли Метрики, но не ломает работу.
export function ensureCounter(id) {
  if (window[`yaCounter${id}`]) return; // счётчик уже инициализирован
  if (typeof window.ym !== "function") {
    // стаб-очередь из официального сниппета: вызовы копятся до загрузки tag.js
    const stub = function (...args) {
      (stub.a = stub.a || []).push(args);
    };
    stub.l = Date.now();
    window.ym = stub;
  }
  if (!document.querySelector(`script[src="${TAG_SRC}"]`)) {
    const s = document.createElement("script");
    s.src = TAG_SRC;
    s.async = true;
    document.head.appendChild(s);
  }
  window.ym(id, "init", { clickmap: true, trackLinks: true, accurateTrackBounce: true });
}

// Безопасно при adblock (window.ym может так и не появиться)
export const sendGoal = (id, goal) => window.ym?.(id, "reachGoal", goal);
